import Vue from 'vue';

const state = {
  cCurrentBaseMapIndex: 0, //当前激活地图集合图层索引
  cBaseMapLayers: [], //底图图层集合数据
  cSpecialLayers: [], //专题图层数据
  cShowLegend: false, //是否显示三维图例
  cShowCutBuild: false, //是否开启房屋揭盖
  cShowAnalysisTool: false,
  cIsDrawing: false, //是否正在绘制
  cShowPlaneAna: false, //平面场景支持的分析
  startQueryFlag: true,
  cShowBuilding: false,
  cOpenPlansInfo: null,//当前场景打开的方案信息
  modelPan: false, //模型编辑面板
  modelCommonPan: false,//普通模型编辑面板
  s3mModelPan: false,//s3m模型编辑面板
  cGeologyFlag: false,
  cShowMapEditPanel:false,//是否显示在线制图面板
  cshowRightButtonControl: false,
  modelThemSetting:{}
};

const getters = {

};

const mutations = {
   cMapEditPanel(state, showMapEditPanel) {
    state.cShowMapEditPanel = showMapEditPanel;
  },
  cRightButtonControlVisible(state, flag) {
    state.cshowRightButtonControl = flag;
  },
  cShowHideBuilding(state, showBuilding) {
    state.cShowBuilding = showBuilding;
  },
  cChangeQueryFlag(state, flag) {
    state.startQueryFlag = flag;
  },
  cShowHidePlane(state, cShowPlaneAna) {
    state.cShowPlaneAna = cShowPlaneAna;
  },
  cAddLegend(state, {
    layer,
    legend
  }) {
    for (let i = 0; i < state.cSpecialLayers.length; i++) {
      if (state.cSpecialLayers[i].key == layer.key) {
        state.cSpecialLayers[i].legend = legend;
        break;
      }
    }
  },
  cShowHideLegend(state, isShowLegend) {
    state.cShowLegend = isShowLegend;
  },
  cShowHideCutBuild(state, isShowCut) {
    state.cShowCutBuild = isShowCut;
  },
  cAddLayer(state, layer) {
    // if (!state.cShowLegend) {
    //     state.cShowLegend = true;
    // }
    //layer.zIndex = state.cSpecialLayers.length == 0 ? 10 : state.cSpecialLayers.length * 10; //默认设置zIndex 方便后续调整图层顺序
    state.cSpecialLayers.push(layer);
  },
  cRemoveLayer(state, layer) {
    if (state.cSpecialLayers.length == 1) {
      state.cshowRightButtonControl = false;
    }
    for (let i = 0; i < state.cSpecialLayers.length; i++) {
      if (state.cSpecialLayers[i].key == layer.key) {
        state.cSpecialLayers.splice(i, 1);
        break;
      }
    }
  },
  cChangeIsDrawing(state, cIsDrawing) {
    state.cIsDrawing = cIsDrawing;
  },
  cShowHideLayer(state, {
    layer,
    flag
  }) {
    for (let i = 0; i < state.cSpecialLayers.length; i++) {
      if (state.cSpecialLayers[i].key == layer.key) {
        state.cSpecialLayers[i].visible = flag;
        break;
      }
    }

  },
  cChangeSpecialLayer(state, { specialLayers, noClearFlag }) {
    if (noClearFlag) {
      state.cSpecialLayers = state.cSpecialLayers.filter((layer) => {
        return layer.noClear;
      });
    } else {
      state.cSpecialLayers = specialLayers;
    }
  },
  cChangeLayerOpacity(state, {
    layer,
    opacity
  }) {
    for (var i = 0; i < state.cSpecialLayers.length; i++) {
      if (state.cSpecialLayers[i].key == layer.key) {
        state.cSpecialLayers[i].opacity = opacity;
      }
    }
  },
  cChangeCurrentBaseMapIndex(state, index) {
    state.currentBaseMapIndex = index;
    var templayer = state.baseMapLayersGroup[0];
    Vue.set(state.baseMapLayersGroup, 0, state.baseMapLayersGroup[index]);
    Vue.set(state.baseMapLayersGroup, index, templayer);
  },
  cChangeLayerZIndex(state, {
    downLayer,
    upLayer
  }) {
    for (let i = 0; i < state.cSpecialLayers.length; i++) {
      if (state.cSpecialLayers[i].key == downLayer.key) {
        var templayer = state.cSpecialLayers[i];
        for (let j = 0; j < state.cSpecialLayers.length; j++) {
          if (state.cSpecialLayers[j].key == upLayer.key) {
            Vue.set(state.cSpecialLayers, i, state.cSpecialLayers[j]);
            Vue.set(state.cSpecialLayers, j, templayer);
            return;
          }
        }
      }
    }
  },
  toggleAnalysisTool(state, flag) {
    state.cShowAnalysisTool = flag;
    state.startQueryFlag = !flag;
  },
  changeOpenPlansInfo(state, flag) {
    state.cOpenPlansInfo = flag;
  },
  changeModelPan(state, flag) {
    state.modelPan = flag;
  },
  cSaveGeologyFlag(state, val) {
    state.cGeologyFlag = val;
  },
  changeModelCommonPan(state, flag) {
    state.modelCommonPan = flag;
  },
  changes3mModelPan(state, flag) {
    state.s3mModelPan = flag;
  },
  changeModelThemSetting(state, obj) {
     Vue.set(state.modelThemSetting, obj.id, obj.themeSettings);
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/scene.js